import { render, staticRenderFns } from "./RelAgendaClientes.vue?vue&type=template&id=2290728a"
import script from "./RelAgendaClientes.vue?vue&type=script&lang=js"
export * from "./RelAgendaClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports